import { render, staticRenderFns } from "./SettingsDialog.vue?vue&type=template&id=752fab61&scoped=true&"
import script from "./SettingsDialog.vue?vue&type=script&lang=js&"
export * from "./SettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./SettingsDialog.vue?vue&type=style&index=0&id=752fab61&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752fab61",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/rec-rich/lib/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('752fab61')) {
      api.createRecord('752fab61', component.options)
    } else {
      api.reload('752fab61', component.options)
    }
    module.hot.accept("./SettingsDialog.vue?vue&type=template&id=752fab61&scoped=true&", function () {
      api.rerender('752fab61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/main2/components/SettingsDialog.vue"
export default component.exports